import { useState } from "react";

import Card from "../card";

import { useApi } from "../../hooks/useApi";
import { buildApiUrl } from "../../api";

import * as Sentry from "@sentry/react";

interface SupportSectionProps {
  teamId: string | null;
}

function SupportSection({ teamId }: SupportSectionProps) {
  const [message, setMessage] = useState("");
  const api = useApi();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      await api.post(buildApiUrl("/v2/users/support", teamId), { message });
      setMessage("");
      // Optionally, show a success message to the user
    } catch (error) {
      Sentry.captureException(error);
      // TODO: show an error message to the user
    }
  };

  return (
    <Card>
      <h2 className="text-xl font-semibold mb-4">Support</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          className="w-full p-2 border rounded bg-gray-100 border-gray-200 text-sm focus:brand focus:ring-brand/80"
          rows={4}
          placeholder="Type your question or issue here..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>
        <div className="flex items-center justify-between mt-4">
          <p className="text-sm text-gray-600 0">
            You can also reach us at{" "}
            <a
              href="mailto:support@trybraid.io"
              className="underline hover:text-brand"
            >
              support@trybraid.io
            </a>{" "}
            or message us in Slack using{" "}
            <code className="bg-brand/10 text-brand">/braid help</code>
          </p>
          <button
            type="submit"
            className="mt-2 bg-white text-black px-4 py-2 rounded-[8px] transition-colors border border-black text-md hover:border-brand hover:ring-brand/80 hover:text-brand"
          >
            Send
          </button>
        </div>
      </form>
    </Card>
  );
}

export default SupportSection;
